export default {
  template: {
    id: undefined,
    name: undefined,
    color: undefined,
    content: undefined,
    content_name: undefined,
  },
};
